import Vue from 'vue';
import App from '@/app.vue';
import router from '@/router';
import store from '@/store';
import '@/plugins/element';
import '@/utils/directives';
import 'default-passive-events';
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');